/**
 * Backend maintenance toggle (chatbot, auth, and API).
 * Set REACT_APP_CHATBOT_MAINTENANCE=true in .env while the on-prem backend is down.
 * Remove the variable or set it to "false", then rebuild to restore normal behavior.
 */
export const isChatbotMaintenanceMode =
  process.env.REACT_APP_CHATBOT_MAINTENANCE === "true";

export const MAINTENANCE_PAGE_PATH = "/ai-chatbot";
